import React from 'react';

import { ISVGPersonalProps } from 'types/svg';

export const edit2: ISVGPersonalProps = {
  viewBox: '0 0 28 28',
  content: (
    <g id="edit_icon_active" data-name="edit icon active" transform="translate(18459.691 2947.492)">
      <rect
        id="Rectangle_2788"
        data-name="Rectangle 2788"
        width="28"
        height="28"
        transform="translate(-18459.691 -2947.492)"
        fill="none"
      />
      <g id="edit" transform="translate(-18454.637 -2942.493)">
        <path
          id="Path_86"
          data-name="Path 86"
          d="M15.521,48.534a.431.431,0,0,0-.419.442V52.9a1.294,1.294,0,0,1-1.256,1.326H2.094A1.294,1.294,0,0,1,.838,52.9V41.382a1.294,1.294,0,0,1,1.256-1.326H5.813a.443.443,0,0,0,0-.884H2.094A2.157,2.157,0,0,0,0,41.382V52.9a2.157,2.157,0,0,0,2.094,2.21H13.846A2.157,2.157,0,0,0,15.94,52.9V48.976A.431.431,0,0,0,15.521,48.534Zm0,0"
          transform="translate(0 -37.452)"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="0.6"
        />
        <path
          id="Path_87"
          data-name="Path 87"
          d="M120.4.843a2.088,2.088,0,0,0-2.894,0L109.39,8.73a.439.439,0,0,0-.117.195l-1.067,3.744a.433.433,0,0,0,.117.431.464.464,0,0,0,.443.113l3.852-1.037a.458.458,0,0,0,.2-.113l8.113-7.886a1.952,1.952,0,0,0,0-2.813ZM110.381,9.017l6.64-6.454,2.141,2.082-6.64,6.454Zm-.428.834,1.711,1.663-2.367.637Zm10.335-6.3-.482.469-2.142-2.082.482-.469a1.16,1.16,0,0,1,1.608,0l.534.519A1.085,1.085,0,0,1,120.288,3.55Zm0,0"
          transform="translate(-103.638 -0.26)"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="0.6"
        />
      </g>
    </g>
  ),
};
